import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
import {
	THEME_COLOR_BLUE,
	THEME_COLOR_GREEN,
	THEME_COLOR_MAIN,
	THEME_COLOR_PINK,
	THEME_COLOR_VIOLET
} from 'src/app/core/services/constant/constants.service';

@Component({
	selector: 'app-planning-repartition',
	templateUrl: './planning-repartition.component.html',
	styleUrls: ['./planning-repartition.component.scss']
})
export class PlanningRepartitionComponent implements OnChanges {
	title = 'Répartition des planning par compétence';

	@Input() lsfStats: any;
	@Input() lpcStats: any;
	@Input() pdnStats: any;
	@Input() oralStats: any;
	planningRepartition: number[] = [];

	chartOption: EChartsOption;

	constructor() {}

	// ngOnInit(): void {}

	ngOnChanges(change: any) {
		if (isNaN(this.lpcStats) && isNaN(this.lsfStats)) {
			try {
				this.updatePlanningRepartitions();
			} catch (error) {}
		}
	}

	updatePlanningRepartitions(): void {
		this.chartOption = {
			// title: {
			//     text: 'Repartition des planning',
			//     subtext: 'Par compétence',
			//     left: 'center',
			// },
			tooltip: {
				trigger: 'item',
				// auparavant dans le formatter : '{a} <br/>{b} : {c} ({d}%)' , avec {a} = series0
				formatter: '{b} : {c} ({d}%)'
			},
			calculable: true,
			series: [
				{
					data: [
						{
							value: this.lpcStats.nombrePlanning,
							itemStyle: { color: THEME_COLOR_BLUE },
							name: 'LPC'
						},
						{
							value: this.lsfStats.nombrePlanning,
							itemStyle: { color: THEME_COLOR_GREEN },
							name: 'LSF'
						},
						{
							value: this.pdnStats.nombrePlanning,
							itemStyle: { color: THEME_COLOR_PINK },
							name: 'PDN'
						},
						{
							value: this.oralStats.nombrePlanning,
							itemStyle: { color: THEME_COLOR_VIOLET },
							name: 'Oral'
						}
					],
					label: {
						show: true,
						color: THEME_COLOR_MAIN
					},
					stillShowZeroSum: true,
					type: 'pie',
					radius: [30, 110],
					roseType: 'radius'
				}
			]
		};
	}
}
